import { observable } from 'mobx'
import Api from '@api/taskCenter'

class Store {
  @observable taskPageData = {}
  @observable ultimateUnlockVisible = false // 商家扶持解锁弹窗
  @observable unlockVisible = false // 任务解锁弹窗

  getTaskPageData = async () => {
    const { data } = await Api.getTaskPageDetail()
    this.taskPageData = data || {}
    this.setModalData(this.taskPageData)
  }

  /**
   * 设置弹窗
   * 弹窗展示优先级：新店扶持计划开启弹窗>任务达成弹窗，若同时存在，先弹前者，前者关闭后再弹后者。
   */
  setModalData = data => {
    if (data.ultimateUnlock) {
      this.ultimateUnlockVisible = true
    } else if (data.unlock) {
      this.unlockVisible = true
    }
  }

  closeUltimateUnlockModal = () => {
    this.ultimateUnlockVisible = false

    if (this.taskPageData.unlock) {
      this.unlockVisible = true
    }
  }

  closeUnlockModal = () => {
    this.unlockVisible = false
  }
}

export default Store
